import VipUpgradeModal from "@/modules/payment/components/VipUpgradeModal";
import Onboarding from "@/components/Onboarding";
import { DistributeFreeCoinModal } from "@/components/Onboarding/mini";
import AcceleratePayment from "@/modules/payment/AcceleratePayment";
import { useBoolean } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Emitter, { MessageType } from "@/utils/events";
import { observer } from "mobx-react-lite";
import { userAssetsStore } from "@/stores/userAssets";
import { CaptchaDataType, CaptchaEvent, CaptchaModal } from "./CaptchaModal";
import PromptExpandModal from "@/modules/editor/components/Modals/PromptExpandModal";

function GlobalModal() {
  const [accelerationOpen, setAccelerationOpen] = useBoolean(false);
  const [captchaOpen, captchaToggle] = useBoolean(false);
  const [captchaData, setCaptchaData] = useState<CaptchaDataType>({
    captcha: "",
    captcha_id: "",
  });
  useEffect(() => {
    Emitter.on(MessageType.HEART_COIN, (e) => {
      if (e?.data?.value || !e) {
        userAssetsStore.setHeartCoinPayModalOpen(true);
      } else {
        userAssetsStore.setHeartCoinPayModalOpen(false);
      }
    });
    return () => {
      Emitter.off(MessageType.HEART_COIN);
    };
  }, [setAccelerationOpen]);

  useEffect(() => {
    Emitter.on(CaptchaEvent.SHOW, (e) => {
      console.log("e: ", e);
      if (e?.data?.captcha) {
        setCaptchaData(e.data.captcha);
        captchaToggle.on();
      }
    });
    return () => {
      Emitter.off(CaptchaEvent.SHOW);
    };
  }, []);
  return (
    <>
      <PromptExpandModal />
      <DistributeFreeCoinModal />
      <Onboarding />
      <VipUpgradeModal />
      <AcceleratePayment open={accelerationOpen} onClose={setAccelerationOpen.off} />
      <CaptchaModal captcha={captchaData} onClose={captchaToggle.off} isOpen={captchaOpen} />
    </>
  );
}

export default observer(GlobalModal);
